import React from 'react';

import {
  AddedProductItemList,
  AddedProductItemRouteParamTypeProps,
  AddedProductsTypes,
  AddedProductsTypesEnum,
} from '../../../../utils/types';
import { Empty } from '../Empty';

import { AddedProductItemCoes } from './Coes';
import { AddedProductItemDirectTreasury } from './DirectTreasury';
import { AddedProductItemEquity } from './Equity';
import { AddedProductItemFixedIncome } from './FixedIncome';
import { AddedProductItemFunds } from './Funds';

export interface InvalidProductData {
  name: string;
  description: string;
}

type AddedProductItemProps = {
  data: AddedProductItemList;
  navigationType: AddedProductItemRouteParamTypeProps;
  offerType: AddedProductsTypes;
};

export const AddedProductItem: React.FC<AddedProductItemProps> = ({
  data,
  offerType,
  navigationType,
}) => {
  const termsOrderIsRecused = ['order_recused', 'suitability_non_compliance'];
  const isInvalid = !!(navigationType === 'requiredAttention' && data?.errors);
  const orderIsRecused = data?.errors?.some((error) =>
    termsOrderIsRecused.some((code) => error.errorCode?.includes(code))
  );

  const params = { data, type: navigationType, isInvalid, orderIsRecused: !!orderIsRecused };

  const offerComponents: Record<AddedProductsTypesEnum, React.ReactNode> = {
    [AddedProductsTypesEnum.FIXED_INCOME]: <AddedProductItemFixedIncome {...params} />,
    [AddedProductsTypesEnum.FUNDS]: <AddedProductItemFunds {...params} />,
    [AddedProductsTypesEnum.COES]: <AddedProductItemCoes {...params} />,
    [AddedProductsTypesEnum.EQUITY]: <AddedProductItemEquity {...params} />,
    [AddedProductsTypesEnum.DIRECT_TREASURY]: <AddedProductItemDirectTreasury {...params} />,
  };

  const content = offerComponents[offerType] || <Empty />;

  return content;
};
